import React from 'react';

// Auth routes
export const LOGIN = React.lazy(() => import('views/auth-views/authentication/login'));
export const FORGOT_PASSWORD = React.lazy(() => import('views/auth-views/authentication/forgot-password'));
export const RESET_PASSWORD = React.lazy(() => import('views/auth-views/authentication/reset-password'));

// Application protected routes
export const USER_ACTIVITY = React.lazy(() => import('views/app-views/userActivity'));
export const JOBS_APPLICATION_METRICS = React.lazy(() => import('views/app-views/jobsAndApplicationMetrics'));
export const SUBSCRIPTION_DETAILS = React.lazy(() => import('views/app-views/subscriptionDetails'));
export const TESTIMONIALS = React.lazy(() => import('views/app-views/testimonials'));
export const COMPANIES = React.lazy(() => import('views/app-views/companies'));
export const CAMPAIGNS = React.lazy(() => import('views/app-views/campaigns'));
export const INVOICES = React.lazy(() => import('views/app-views/invoices/CompanyInvoices'));
export const INVOICE_DETAILS = React.lazy(() => import('views/app-views/invoices/InvoiceDetails'));
export const PAYMENT_PACKAGES = React.lazy(() => import('views/app-views/paymentPackages'));
